import { useCart } from '@chordcommerce/react-autonomy';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { FBC_COOKIE, FBP_COOKIE } from '~/utils/constants';

/**
 * This hook is used to add the Facebook Pixel data to the cart metadata.
 */
const useFacebookPixelCartData = () => {
  const { modifyCart } = useCart();
  useEffect(() => {
    const fbp = Cookies.get(FBP_COOKIE);
    const fbc = Cookies.get(FBC_COOKIE);

    if (!fbp || !fbc) return;
    const modifyWithNewData = async () => {
      await modifyCart({
        attributes: {
          metadata: {
            fbp,
            fbc,
          },
        },
      });
    };
    modifyWithNewData();
  }, [modifyCart]);
};

export default useFacebookPixelCartData;
